import AppConst from "../AppConst";
import { AppInitDto, LoginDto, RegisterDto, BookingDto, RentalBookingDto, CartDto, CartItemDto, CardDetailsDto } from "../types";
import { message } from "antd";
import SjclManager from "../encryption/SjclManager.js";
import AtsJT from "@/cookies/AtsJT.js";
import Cookie from "@/cookies/Cookie.js";

export const AppService = {
  init: async (): Promise<AppInitDto> => {
    try {
      const response = await fetch(AppConst.GLOBALS.initUrl, {
        credentials: "include",
      });

      if (!response.ok) {
        message.error({
          content: "Error network",
          duration: AppConst.msgDuration,
        });
        return null;
      }

      const jsonResponse = await response.json();

      AppConst.webappName = jsonResponse.payload.webappDomain;
      AppConst.webappVersion = jsonResponse.payload.webappVersion;
      AppConst.isLoggedIn = jsonResponse.payload.userStatus;
      AppConst.username = jsonResponse.payload.userName;
      AppConst.LOGIN_INIT = jsonResponse.payload;
      AppConst.LOGOUT_INIT = jsonResponse.payload;

      console.log(jsonResponse);

      return jsonResponse;
    } catch (error) {
      message.error({
        content: "Initialization failed",
        duration: AppConst.msgDuration,
      });

      return {} as AppInitDto;
    }
  },

  getDictionary: async (): Promise<DictDto[]> => {
       try {
            const response = await fetch(AppConst.GLOBALS.getDictionaryUrl, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
              },
              credentials: 'include',
            });

            if (!response.ok) {
              message.error({
                content: "Eroare de rețea",
                duration: AppConst.msgDuration,
              });
              return [];
            }

            return await response.json() as DictDto[];
          } catch (error) {
            console.warn("Eroare de rețea");
            return [];
          }
      },

  getAppConfigMap: async (): Promise<Map<string, AppConfigDto>> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getAppConfigMapUrl, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });

      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        // 💡 FIX: Returnăm un Map gol în caz de eroare HTTP, nu un array []
        return new Map<string, AppConfigDto>();
      }

      // 💡 FIX: API-ul returnează un obiect JSON normal (Record<string, AppConfigDto>)
      const data = await response.json() as Record<string, AppConfigDto>;

      // 💡 FIX: Transformăm obiectul JSON primit într-o instanță reală de Map Java-style
      return new Map<string, AppConfigDto>(Object.entries(data));

    } catch (error) {
      console.warn("Eroare de rețea", error);
      // 💡 FIX: Returnăm un Map gol și pe ramura de catch pentru consistență
      return new Map<string, AppConfigDto>();
    }
  },

  enabledFunctions: async (): Promise<EnabledFunctionsDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.enabledFunctionsUrl, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });

      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        return [];
      }

      return await response.json() as EnabledFunctionsDto[];
    } catch (error) {
      console.warn("Eroare de rețea");
      return [];
    }
  },

  termsConditions: async (): Promise<any> => {
    try {
      const response = await fetch(AppConst.GLOBALS.termsConditionsUrl, {
        method: "POST",
        credentials: "include",
      });
      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        return null;
      }

      return await response.json();
    } catch (error) {
      console.warn("Eroare de rețea");
      return null;
    }
  },

  login: async (loginDto: LoginDto): Promise<any> => {
    try {
      var publicKey = AppConst.LOGIN_INIT.frameworkCSPF;
      var aDataCSPF = AppConst.LOGIN_INIT.aDataCSPF;
      var passEP = AppConst.LOGIN_INIT.passEP;

      const passEncrypted = SjclManager.doEncrypt(passEP, aDataCSPF, loginDto.password);
      const jsPayloadAsStr = JSON.stringify({ userName: loginDto.userName, email: loginDto.email, password: passEncrypted });
      const payloadEncrypted = SjclManager.doEncrypt(publicKey, aDataCSPF, jsPayloadAsStr);

      const response = await fetch(AppConst.GLOBALS.loginUrl, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: payloadEncrypted,
      });
      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        return null;
      }

      const jsonResponse = await response.json();

      if (jsonResponse.messages && jsonResponse.messages.length > 0) {
        jsonResponse.messages.forEach((msg: any) => {
          const serverMessage = msg.description;
          if (msg.type === "SUCCESS") {
            message.success({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });

            const pureToken = AtsJT.extractToken();
            Cookie.setCookie(AppConst.AtJST, pureToken);
            Cookie.deleteCookie(AppConst.AtST);
          } else if (msg.type === "ERROR") {
            message.error({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });
          }
        });
      }
      return await jsonResponse;
    } catch (error) {
      console.warn("Eroare de rețea");
      return null;
    }
  },

  logout: async (): Promise<boolean> => {
    try {
      const response = await fetch(AppConst.GLOBALS.logoutUrl, {
        method: "POST",
        credentials: "include",
      });

      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        return false;
      }

      const jsonResponse = await response.json();

      let success = false;

      if (jsonResponse.messages && jsonResponse.messages.length > 0) {
        jsonResponse.messages.forEach((msg: any) => {
          if (msg.type === "SUCCESS") {
            message.success({
              content: "Te-ai delogat cu succes",
              duration: AppConst.msgDuration,
            });
            success = true;
          } else if (msg.type === "ERROR") {
            message.error({
              content: "Logout eșuat",
              duration: AppConst.msgDuration,
            });
          }
        });
      }

      AppConst.isLoggedIn = false;
      AppConst.username = null;
      AppConst.LOGIN_INIT = null;
      AppConst.LOGOUT_INIT = null;

      return success;
    } catch (error) {
      message.error({
        content: "Eroare de rețea",
        duration: AppConst.msgDuration,
      });
      return false;
    }
  },

  register: async (registerDto: RegisterDto): Promise<any> => {
    try {
      var publicKey = AppConst.LOGIN_INIT.frameworkCSPF;
      var aDataCSPF = AppConst.LOGIN_INIT.aDataCSPF;
      var passEP = AppConst.LOGIN_INIT.passEP;

      const passEncrypted = SjclManager.doEncrypt(passEP, aDataCSPF, registerDto.encryptedPassword);
      const jsPayloadAsStr = JSON.stringify({
        firstName: registerDto.firstName,
        lastName: registerDto.lastName,
        userName: registerDto.userName,
        email: registerDto.email,
        phone: registerDto.phone,
        encryptedPassword: passEncrypted,
        seller: registerDto.seller,
        termsConditions: registerDto.termsConditions,
      });
      const payloadEncrypted = SjclManager.doEncrypt(publicKey, aDataCSPF, jsPayloadAsStr);

      const response = await fetch(AppConst.GLOBALS.registerUrl, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: payloadEncrypted,
      });
      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        return null;
      }

      const jsonResponse = await response.json();

      if (jsonResponse.messages && jsonResponse.messages.length > 0) {
        jsonResponse.messages.forEach((msg: any) => {
          const serverMessage = msg.description;
          if (msg.type === "SUCCESS") {
            message.success({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });
          } else if (msg.type === "ERROR") {
            message.error({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });
          }
        });
      }
      return await jsonResponse;
    } catch (error) {
      console.warn("Eroare de rețea");
      return null;
    }
  },

  configureSellerAccount: async (user: UserDto): Promise<boolean> => {
    const payloadString = JSON.stringify(user);

    const response = await fetch(AppConst.GLOBALS.configureSellerAccountUrl, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: payloadString,
    });

    if (!response.ok) {
      message.error({
        content: "Eroare de rețea",
        duration: AppConst.msgDuration,
      });
      return false;
    }

    const jsonResponse = await response.json();

    if (jsonResponse.messages && jsonResponse.messages.length > 0) {
      jsonResponse.messages.forEach((msg: any) => {
        const serverMessage = msg.description;
        if (msg.type === "SUCCESS") {
          message.success({
            content: serverMessage,
            duration: AppConst.msgDuration,
          });
          return true;
        } else if (msg.type === "ERROR") {
          message.error({
            content: serverMessage,
            duration: AppConst.msgDuration,
          });
          return false;
        }
      });
    }
  },

  updateUserAccount: async (user: UserDto): Promise<boolean> => {
      const payloadString = JSON.stringify(user);

      const response = await fetch(AppConst.GLOBALS.updateUserAccountUrl, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: payloadString,
      });

      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        return false;
      }

      const jsonResponse = await response.json();

      if (jsonResponse.messages && jsonResponse.messages.length > 0) {
        jsonResponse.messages.forEach((msg: any) => {
          const serverMessage = msg.description;
          if (msg.type === "SUCCESS") {
            message.success({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });
            return true;
          } else if (msg.type === "ERROR") {
            message.error({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });
            return false;
          }
        });
      }
    },

  validateIban: async (iban: string): Promise<boolean> => {
      try {
        const publicKey = AppConst.LOGIN_INIT.frameworkCSPF;
        const aDataCSPF = AppConst.LOGIN_INIT.aDataCSPF;

        const encryptedPayload = SjclManager.doEncrypt(publicKey, aDataCSPF, iban);

        const response = await fetch(
          AppConst.GLOBALS.validateIbanUrl,
          {
            method: "POST",
            headers: {
              "Content-Type": "text/plain"
            },
            credentials: "include",
            body: encryptedPayload
          }
        );

        if (!response.ok) return false;

        return await response.json();
      } catch {
        return false;
      }
    },

  validateVatId: async (vatId: string): Promise<boolean> => {
        try {
          const publicKey = AppConst.LOGIN_INIT.frameworkCSPF;
          const aDataCSPF = AppConst.LOGIN_INIT.aDataCSPF;

          const encryptedPayload = SjclManager.doEncrypt(publicKey, aDataCSPF, vatId);

          const response = await fetch(
            AppConst.GLOBALS.validateVatIdUrl,
            {
              method: "POST",
              headers: {
                "Content-Type": "text/plain"
              },
              credentials: "include",
              body: encryptedPayload
            }
          );

          if (!response.ok) return false;

          return await response.json();
        } catch {
          return false;
        }
      },

  fieldExists: async (field: string, value: string): Promise<boolean> => {
    try {
      const publicKey = AppConst.LOGIN_INIT.frameworkCSPF;
      const aDataCSPF = AppConst.LOGIN_INIT.aDataCSPF;

      const payloadAsStr = JSON.stringify({
        field: field,
        value: value
      });

      const encryptedPayload = SjclManager.doEncrypt(publicKey, aDataCSPF, payloadAsStr);

      const response = await fetch(
        AppConst.GLOBALS.existentFieldUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "text/plain"
          },
          credentials: "include",
          body: encryptedPayload
        }
      );

      if (!response.ok) return false;

      return await response.json();
    } catch {
      return false;
    }
  },

  saveAircraftListing: async (
      listing: AircraftListingDto,
      details: AircraftListingDetailsDto
    ): Promise<AircraftListingDto | null> => {
      try {
        const formData = new FormData();
        const { media, ...textProperties } = listing;

        formData.append("aircraftListingAsJson", JSON.stringify(textProperties));
        formData.append("aircraftListingDetailsAsJson", JSON.stringify(details));

        if (media && media.length > 0) {
          media.forEach((file) => {
            formData.append("media", file);
          });
        }

        const response = await fetch(AppConst.GLOBALS.saveAircraftListingUrl, {
          method: "POST",
          credentials: "include",
          body: formData,
        });

        if (!response.ok) {
          return null;
        }
        return (await response.json()) as AircraftListingDto;
      } catch (error) {
        console.error("Error inside saveAircraft transmission layer:", error);
        return null;
      }
    },

  saveAircraftRental: async (
      rental: AircraftRentalDto,
      details: AircraftRentalDetailsDto
    ): Promise<AircraftRentalDto | null> => {
      try {
        const formData = new FormData();
        const { media, ...textProperties } = rental;

        formData.append("aircraftRentalAsJson", JSON.stringify(textProperties));
        formData.append("aircraftRentalDetailsAsJson", JSON.stringify(details));

        if (media && media.length > 0) {
          media.forEach((file) => formData.append("media", file));
        }

        const response = await fetch(AppConst.GLOBALS.saveAircraftRentalUrl, {
          method: "POST",
          credentials: "include",
          body: formData,
        });

        if (!response.ok) return null;
        return (await response.json()) as AircraftRentalDto;
      } catch (error) {
        console.error("Error inside saveAircraftRental transmission layer:", error);
        return null;
      }
    },

  saveAircraftPart: async (
      part: PartDto,
      details: PartDetailsDto
    ): Promise<PartDto | null> => {
      try {
        const formData = new FormData();
        const { media, ...textProperties } = part;

        formData.append("aircraftPartAsJson", JSON.stringify(textProperties));
        formData.append("aircraftPartDetailsAsJson", JSON.stringify(details));

        if (media && media.length > 0) {
          media.forEach((file) => formData.append("media", file));
        }

        const response = await fetch(AppConst.GLOBALS.saveAircraftPartUrl, {
          method: "POST",
          credentials: "include",
          body: formData,
        });

        if (!response.ok) return null;
        return (await response.json()) as PartDto;
      } catch (error) {
        console.error("Error inside saveAircraftPart transmission layer:", error);
        return null;
      }
    },

  saveExperience: async (
      experience: ExperienceDto,
      details: ExperienceDetailsDto
    ): Promise<ExperienceDto | null> => {
      try {
        const formData = new FormData();
        const { media, ...textProperties } = experience;

        formData.append("experienceAsJson", JSON.stringify(textProperties));
        formData.append("experienceDetailsAsJson", JSON.stringify(details));

        if (media && media.length > 0) {
          media.forEach((file) => formData.append("media", file));
        }

        const response = await fetch(AppConst.GLOBALS.saveExperienceUrl, {
          method: "POST",
          credentials: "include",
          body: formData,
        });

        if (!response.ok) return null;
        return (await response.json()) as ExperienceDto;
      } catch (error) {
        console.error("Error inside saveExperience transmission layer:", error);
        return null;
      }
    },

  saveMedia: async (mediaDto: MediaDto): Promise<{ success: boolean }> => {
    try {
      if (!mediaDto.mediaFiles || mediaDto.mediaFiles.length === 0) return { success: false };

      const formData = new FormData();

      formData.append("listingId", mediaDto.listingId.toString());

      mediaDto.mediaFiles.forEach((file) => {
        formData.append("mediaFiles", file);
      });

      formData.append("listingType", mediaDto.listingType);

      const response = await fetch(AppConst.GLOBALS.saveMediaUrl, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      if (!response.ok) {
        return { success: false };
      }

      const result = await response.json();
      return { success: result === true };
    } catch (err) {
      console.error(err);
      return { success: false };
    }
  },

  getAircraftListing: async (aircraftListingId: number): Promise<AircraftListingDto | null> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getAircraftListingUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(aircraftListingId),
        });

        if (!response.ok) {
          message.error({ content: "Eroare la încărcarea aeronavei", duration: AppConst.msgDuration });
          return null;
        }

        const jsonResponse = await response.json();

        if (!jsonResponse) return null;

        return jsonResponse as AircraftListingDto;
      } catch (error) {
        console.error("Eroare la încărcarea aeronavei", error);
        message.error({ content: "Eroare de rețea la încărcarea aeronavei", duration: AppConst.msgDuration });
        return null;
      }
    },

  getAircraftListingDetails: async (aircraftListingId: number): Promise<AircraftListingDetailsDto | null> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getAircraftListingDetailsUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(aircraftListingId),
        });

        if (!response.ok) {
          message.error({
            content: "Eroare la încărcarea detaliilor aeronavei",
            duration: AppConst.msgDuration,
          });
          return null;
        }

        const jsonResponse = await response.json();
        if (!jsonResponse) return null;

        return jsonResponse as AircraftListingDetailsDto;
      } catch (error) {
        console.error("Eroare la încărcarea detaliilor aeronavei", error);
        message.error({
          content: "Eroare de rețea la încărcarea detaliilor aeronavei",
          duration: AppConst.msgDuration,
        });
        return null;
      }
    },

  getAircraftRental: async (aircraftRentalId: number): Promise<AircraftRentalDto | null> => {
        try {
          const response = await fetch(AppConst.GLOBALS.getAircraftRentalUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(aircraftListingId),
          });

          if (!response.ok) {
            message.error({ content: "Eroare la încărcarea aeronavei", duration: AppConst.msgDuration });
            return null;
          }

          const jsonResponse = await response.json();

          if (!jsonResponse) return null;

          return jsonResponse as AircraftListingDto;
        } catch (error) {
          console.error("Eroare la încărcarea aeronavei", error);
          message.error({ content: "Eroare de rețea la încărcarea aeronavei", duration: AppConst.msgDuration });
          return null;
        }
      },

  getAircraftRentalDetails: async (aircraftRentalId: number): Promise<AircraftRentalDetailsDto | null> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getAircraftRentalDetailsUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(aircraftRentalId),
        });

        if (!response.ok) {
          message.error({
            content: "Eroare la încărcarea detaliilor închirierii",
            duration: AppConst.msgDuration,
          });
          return null;
        }

        const jsonResponse = await response.json();
        if (!jsonResponse) return null;

        return jsonResponse as AircraftRentalDetailsDto;
      } catch (error) {
        console.error("Eroare la încărcarea detaliilor închirierii", error);
        message.error({
          content: "Eroare de rețea la încărcarea detaliilor închirierii",
          duration: AppConst.msgDuration,
        });
        return null;
      }
    },

  getAircraftPart: async (partId: number): Promise<PartDto | null> => {
        try {
          const response = await fetch(AppConst.GLOBALS.getAircraftPartUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(partId),
          });

          if (!response.ok) {
            message.error({ content: "Eroare la încărcarea piesei", duration: AppConst.msgDuration });
            return null;
          }

          const jsonResponse = await response.json();

          if (!jsonResponse) return null;

          return jsonResponse as AircraftListingDto;
        } catch (error) {
          console.error("Eroare la încărcarea piesei", error);
          message.error({ content: "Eroare de rețea la încărcarea piesei", duration: AppConst.msgDuration });
          return null;
        }
      },

  getAircraftPartDetails: async (partId: number): Promise<PartDetailsDto | null> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getAircraftPartDetailsUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(partId),
        });

        if (!response.ok) {
          message.error({
            content: "Eroare la încărcarea detaliilor piesei",
            duration: AppConst.msgDuration,
          });
          return null;
        }

        const jsonResponse = await response.json();
        if (!jsonResponse) return null;

        return jsonResponse as PartDetailsDto;
      } catch (error) {
        console.error("Eroare la încărcarea detaliilor piesei", error);
        message.error({
          content: "Eroare de rețea la încărcarea detaliilor piesei",
          duration: AppConst.msgDuration,
        });
        return null;
      }
    },

  getExperience: async (experienceId: number): Promise<ExperienceDto | null> => {
          try {
            const response = await fetch(AppConst.GLOBALS.getExperienceUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify(experienceId),
            });

            if (!response.ok) {
              message.error({ content: "Eroare la încărcarea experientei", duration: AppConst.msgDuration });
              return null;
            }

            const jsonResponse = await response.json();

            if (!jsonResponse) return null;

            return jsonResponse as AircraftListingDto;
          } catch (error) {
            console.error("Eroare la încărcarea experientei", error);
            message.error({ content: "Eroare de rețea la încărcarea experientei", duration: AppConst.msgDuration });
            return null;
          }
        },

  getExperienceDetails: async (experienceId: number): Promise<ExperienceDetailsDto | null> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getExperienceDetailsUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(experienceId),
        });

        if (!response.ok) {
          message.error({
            content: "Eroare la încărcarea detaliilor experienței",
            duration: AppConst.msgDuration,
          });
          return null;
        }

        const jsonResponse = await response.json();
        if (!jsonResponse) return null;

        return jsonResponse as ExperienceDetailsDto;
      } catch (error) {
        console.error("Eroare la încărcarea detaliilor experienței", error);
        message.error({
          content: "Eroare de rețea la încărcarea detaliilor experienței",
          duration: AppConst.msgDuration,
        });
        return null;
      }
    },

  getAllAircraftListings: async (): Promise<AircraftListingDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getAllAircraftListingsUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (!response.ok) {
        message.error({ content: "Eroare la încărcarea listelor de aeronave", duration: AppConst.msgDuration });
        return [];
      }

      const jsonResponse = await response.json();

      if (!jsonResponse) return [];

      return jsonResponse as AircraftListingDto[];
    } catch (error) {
      console.error("Eroare la încărcarea listelor de aeronave", error);
      message.error({ content: "Eroare de rețea la încărcarea listelor de aeronave", duration: AppConst.msgDuration });
      return [];
    }
  },

  getAllAircraftRentals: async (): Promise<AircraftRentalDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getAllAircraftRentalsUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (!response.ok) {
        message.error({ content: "Eroare la încărcarea listelor de închiriere aeronave", duration: AppConst.msgDuration });
        return [];
      }

      const jsonResponse = await response.json();

      if (!jsonResponse) return [];

      return jsonResponse as AircraftListingDto[];
    } catch (error) {
      console.error("Eroare la încărcarea listelor de închiriere aeronave", error);
      message.error({ content: "Eroare de rețea la încărcarea listelor de închiriere aeronave", duration: AppConst.msgDuration });
      return [];
    }
  },

  getAllAircraftParts: async (): Promise<PartDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getAllAircraftPartsUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (!response.ok) {
        message.error({ content: "Eroare la încărcarea listelor de accesorii aeronave", duration: AppConst.msgDuration });
        return [];
      }

      const jsonResponse = await response.json();

      if (!jsonResponse) return [];

      return jsonResponse as PartDto[];
    } catch (error) {
      console.error("Eroare la încărcarea listelor de accesorii aeronave", error);
      message.error({ content: "Eroare de rețea la încărcarea listelor de accesorii aeronave", duration: AppConst.msgDuration });
      return [];
    }
  },

  getAllExperiences: async (): Promise<ExperienceDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getAllExperiencesUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });

      if (!response.ok) {
        message.error({ content: "Eroare la încărcarea listelor de experiente", duration: AppConst.msgDuration });
        return [];
      }

      const jsonResponse = await response.json();

      if (!jsonResponse) return [];

      return jsonResponse as AircraftListingDto[];
    } catch (error) {
      console.error("Eroare la încărcarea listelor de experiente", error);
      message.error({ content: "Eroare de rețea la încărcarea listelor de experiente", duration: AppConst.msgDuration });
      return [];
    }
  },

  getAircraftListingsCount: async (): Promise<number> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getPublicAircraftListingsCountUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

        if (!response.ok) return 0;
        const count = await response.json();
        return typeof count === "number" ? count : 0;
      } catch (error) {
        console.error("Eroare la încărcarea numărului de aeronave", error);
        return 0;
      }
    },

    getAircraftRentalsCount: async (): Promise<number> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getPublicAircraftRentalsCountUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

        if (!response.ok) return 0;
        const count = await response.json();
        return typeof count === "number" ? count : 0;
      } catch (error) {
        console.error("Eroare la încărcarea numărului de închirieri", error);
        return 0;
      }
    },

    getAircraftPartsCount: async (): Promise<number> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getPublicAircraftPartsCountUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

        if (!response.ok) return 0;
        const count = await response.json();
        return typeof count === "number" ? count : 0;
      } catch (error) {
        console.error("Eroare la încărcarea numărului de piese", error);
        return 0;
      }
    },

    getExperiencesCount: async (): Promise<number> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getPublicExperiencesCountUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

        if (!response.ok) return 0;
        const count = await response.json();
        return typeof count === "number" ? count : 0;
      } catch (error) {
        console.error("Eroare la încărcarea numărului de experiențe", error);
        return 0;
      }
    },

  getAllMedia: async (listingType: string): Promise<MediaDto[] | null> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getAllMediaUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: listingType,
      });

      if (!response.ok) {
        return null;
      }

      const text = await response.text();

      if (!text) return [];

      return JSON.parse(text) as MediaDto[];
    } catch (error) {
      console.error("Eroare la încărcarea fișierelor media", error);
      return null;
    }
  },

  addBookings: async (bookingDtos: BookingDto[]): Promise<boolean> => {
    try {
      const payload = JSON.stringify(bookingDtos);

      const response = await fetch(AppConst.GLOBALS.addBookingsUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: payload,
      });

      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return false;
      }

      const resultText = await response.text();

      return resultText.toLowerCase() === "true";
    } catch (error) {
      console.error("Eroare de rețea la salvarea booking-urilor", error);
      return false;
    }
  },

  requestAircraftRentalBooking: async (bookingDto: AircraftRentalBookingDto): Promise<boolean> => {
    try {
      const response = await fetch(AppConst.GLOBALS.requestAircraftRentalBookingUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: JSON.stringify(bookingDto),
      });

      if (!response.ok) return false;
      const resultText = await response.text();
      return resultText.toLowerCase() === "true";
    } catch (error) {
      console.error("Eroare de rețea la cererea de rezervare", error);
      return false;
    }
  },

   requestExperienceBooking: async (experienceBookingDto: ExperienceBookingDto): Promise<boolean> => {
      try {
        const payload = JSON.stringify(experienceBookingDto);

        const response = await fetch(AppConst.GLOBALS.requestExperienceBookingUrl, {
          method: "POST",
          headers: {
            "Content-Type": "text/plain",
          },
          credentials: "include",
          body: payload,
        });

        if (!response.ok) {
          console.error(`Eroare la server: ${response.status}`);
          return false;
        }

        const resultText = await response.text();

        return resultText.toLowerCase() === "true";
      } catch (error) {
        console.error("Eroare de rețea la salvarea booking-urilor", error);
        return false;
      }
    },

  requestViewing: async (aircraftListingDto: AircraftListingDto): Promise<boolean> => {
    try {
      const payload = JSON.stringify(aircraftListingDto);

      const response = await fetch(AppConst.GLOBALS.requestViewingUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: payload,
      });

      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return false;
      }

      const resultText = await response.text();

      return resultText.toLowerCase() === "true";
    } catch (error) {
      console.error("Eroare de rețea la salvarea booking-urilor", error);
      return false;
    }
  },

  getCart: async (userDto: UserDto): Promise<CartDto> => {
    try {
      const payload = JSON.stringify(userDto);

      const response = await fetch(AppConst.GLOBALS.getCartUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: payload,
      });

      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return null;
      }

      return await response.json();
    } catch (error) {
      console.error("Eroare de rețea la returnarea cosului", error);
      return null;
    }
  },

  removeCartItem: async (cartItemDto: CartItemDto): Promise<boolean> => {
    try {
      const payload = JSON.stringify(cartItemDto);

      const response = await fetch(AppConst.GLOBALS.removeCartItemUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: payload,
      });

      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return false;
      }

      const resultText = await response.text();
      return resultText.toLowerCase() === "true";
    } catch (error) {
      console.error("Eroare de rețea la stergerea produsului din cos", error);
      return false;
    }
  },

  addToCart: async (listing: any, type: string): Promise<CartItemDto> => {
    try {
      const payloadAsStr = JSON.stringify({
        productType: type,
        product: listing
      });
      const response = await fetch(AppConst.GLOBALS.addToCart, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: payloadAsStr,
      });

      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return null;
      }

      return await response.json();
    } catch (error) {
      console.error("Eroare de rețea la adaugarea produsului in cos", error);
      return null;
    }
  },

  processCardPayment: async (cartItems: CartItemDto[], cardDetails: CardDetailsDto, billingDetails: BillingAddressDto): Promise<boolean> => {
    try {
      var passEP = AppConst.LOGIN_INIT.passEP;
      var aDataCSPF = AppConst.LOGIN_INIT.aDataCSPF;

      const paymentPayload = {
        cartItems: cartItems,
        cardDetails: cardDetails,
        billingDetails: billingDetails,
      };

      const payload = JSON.stringify(paymentPayload);

      const payloadEncrypted = SjclManager.doEncrypt(passEP, aDataCSPF, payload);

      const response = await fetch(AppConst.GLOBALS.processCardPaymentUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: payloadEncrypted,
      });

      if (!response.ok) {
        message.error({
          content: "Eroare de rețea",
          duration: AppConst.msgDuration,
        });
        return false;
      }

      const jsonResponse = await response.json();
      let isActuallySuccessful = false;

      if (jsonResponse.messages && jsonResponse.messages.length > 0) {
        jsonResponse.messages.forEach((msg: any) => {
          const serverMessage = msg.description;
          if (msg.type === "SUCCESS") {
            isActuallySuccessful = true;
            message.success({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });
          } else if (msg.type === "ERROR") {
            message.error({
              content: serverMessage,
              duration: AppConst.msgDuration,
            });
          }
        });
      }
      return isActuallySuccessful;
    } catch (error) {
      console.warn("Eroare de rețea");
      return false;
    }
  },

  getMyOrders: async (): Promise<OrderDto[]> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getMyOrdersUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include"
        });
        if (!response.ok) {
          console.error(`Eroare la server: ${response.status}`);
          return false;
        }

        return await response.json();
      } catch (error) {
        console.error("Eroare de rețea la returnarea comenzilor", error);
        return null;
      }
    },

  getMyListings: async (): Promise<AircraftListingDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getMyListingsUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return false;
      }

      return await response.json();
    } catch (error) {
      console.error("Eroare de rețea la returnarea listarilor", error);
      return null;
    }
  },

  getMyRentals: async (): Promise<AircraftRentalDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getMyRentalsUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return null;
      }

      return await response.json();
    } catch (error) {
      console.error("Eroare de rețea la returnarea inchirierilor", error);
      return null;
    }
  },

  getMyParts: async (): Promise<PartDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getMyPartsUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return false;
      }

      return await response.json();
    } catch (error) {
      console.error("Eroare de rețea la returnarea pieselor", error);
      return null;
    }
  },

  getMyExperiences: async (): Promise<ExperienceDto[]> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getMyExperiencesUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return false;
      }

      return await response.json();
    } catch (error) {
      console.error("Eroare de rețea la returnarea experientelor", error);
      return null;
    }
  },

  updateAircraftListing: async (
        listing: AircraftListingDto,
        details: AircraftListingDetailsDto
      ): Promise<AircraftListingDto | null> => {
        try {
          const formData = new FormData();
          const { media, ...textProperties } = listing;

          formData.append("aircraftListingAsJson", JSON.stringify(textProperties));
          formData.append("aircraftListingDetailsAsJson", JSON.stringify(details));

          if (media && media.length > 0) {
            media.forEach((file) => {
              formData.append("media", file);
            });
          }

          const response = await fetch(AppConst.GLOBALS.updateAircraftListingUrl, {
            method: "POST",
            credentials: "include",
            body: formData,
          });

          if (!response.ok) {
            return null;
          }

          return (await response.json()) as AircraftListingDto;
        } catch (error) {
          console.error("Eroare de rețea la editarea listingului", error);
          return null;
        }
      },

  updateAircraftRental: async (
        rental: AircraftRentalDto,
        details: AircraftRentalDetailsDto,
      ): Promise<AircraftRentalDto | null> => {
        try {
            const formData = new FormData();
            const { media, ...textProperties } = rental;
            formData.append("aircraftRentalAsJson", JSON.stringify(textProperties));
            formData.append("aircraftRentalDetailsAsJson", JSON.stringify(details));

            if (media && media.length > 0) {
              media.forEach((file) => formData.append("media", file));
            }

            const response = await fetch(AppConst.GLOBALS.updateAircraftRentalUrl, {
              method: "POST",
              credentials: "include",
              body: formData,
            });

            if (!response.ok) return null;
            return (await response.json()) as AircraftRentalDto;
          } catch (error) {
            console.error("Eroare de rețea la editarea rentalului", error);
            return null;
          }
      },

  updateAircraftPart: async (
      part: PartDto,
      details: PartDetailsDto
    ): Promise<PartDto | null> => {
      try {
        const formData = new FormData();
        const { media, ...textProperties } = part;

        formData.append("aircraftPartAsJson", JSON.stringify(textProperties));
        formData.append("aircraftPartDetailsAsJson", JSON.stringify(details));

        if (media && media.length > 0) {
          media.forEach((file) => formData.append("media", file));
        }

        const response = await fetch(AppConst.GLOBALS.updateAircraftPartUrl, {
          method: "POST",
          credentials: "include",
          body: formData,
        });

        if (!response.ok) return null;
        return (await response.json()) as PartDto;
      } catch (error) {
        console.error("Eroare de rețea la editarea piesei", error);
        return null;
      }
    },

  updateExperience: async (
        experience: ExperienceDto,
        details: ExperienceDetailsDto,
        removedBookingIds: number[]
      ): Promise<ExperienceDto | null> => {
        try {
          const formData = new FormData();
          const { media, ...textProperties } = experience;

          const payloadAsJsonStructure = {
            experience: textProperties,
            deletedBookingIds: removedBookingIds
          };

          formData.append("experienceAsJson", JSON.stringify(payloadAsJsonStructure));
          formData.append("experienceDetailsAsJson", JSON.stringify(details));

          if (media && media.length > 0) {
            media.forEach((file) => formData.append("media", file));
          }

          const response = await fetch(AppConst.GLOBALS.updateExperienceUrl, {
            method: "POST",
            credentials: "include",
            body: formData,
          });

          if (!response.ok) return null;
          return (await response.json()) as ExperienceDto;
        } catch (error) {
          console.error("Eroare de rețea la editarea experientei", error);
          return null;
        }
      },

    toggleAircraftActiveState: async (listingId: number): Promise<boolean> => {
            try {
              const response = await fetch(AppConst.GLOBALS.toggleAircraftActiveStateUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify(listingId),
              });

              if (!response.ok) {
                console.error(`Eroare la server: ${response.status}`);
                return false;
              }

              return await response.json() as boolean;
            } catch (error) {
              console.error("Eroare de rețea la schimbarea starii de activare a listarii", error);
              return false;
            }
          },

      toggleRentalActiveState: async (rentalId: number): Promise<boolean> => {
                  try {
                    const response = await fetch(AppConst.GLOBALS.toggleRentalActiveStateUrl, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      credentials: "include",
                      body: JSON.stringify(rentalId),
                    });

                    if (!response.ok) {
                      console.error(`Eroare la server: ${response.status}`);
                      return false;
                    }

                    return await response.json() as boolean;
                  } catch (error) {
                    console.error("Eroare de rețea la schimbarea starii de activare a inchirierii", error);
                    return false;
                  }
                },
    togglePartActiveState: async (partId: number): Promise<boolean> => {
                      try {
                        const response = await fetch(AppConst.GLOBALS.togglePartActiveStateUrl, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                          },
                          credentials: "include",
                          body: JSON.stringify(partId),
                        });

                        if (!response.ok) {
                          console.error(`Eroare la server: ${response.status}`);
                          return false;
                        }

                        return await response.json() as boolean;
                      } catch (error) {
                        console.error("Eroare de rețea la schimbarea starii de activare a piesei", error);
                        return false;
                      }
                    },

    toggleExperienceActiveState: async (experienceId: number): Promise<boolean> => {
        try {
          const response = await fetch(AppConst.GLOBALS.toggleExperienceActiveStateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(experienceId),
          });

          if (!response.ok) {
            console.error(`Eroare la server: ${response.status}`);
            return false;
          }

          return await response.json() as boolean;
        } catch (error) {
          console.error("Eroare de rețea la schimbarea starii de a activare a experienței", error);
          return false;
        }
      },

  deleteMedia: async (mediaIds: number[]): Promise<boolean> => {
    try {
      const payload = JSON.stringify(mediaIds);

      const response = await fetch(AppConst.GLOBALS.deleteMediaUrl, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
        },
        credentials: "include",
        body: payload,
      });

      if (!response.ok) {
        console.error(`Eroare la server: ${response.status}`);
        return false;
      }

      const resultText = await response.text();

      return resultText.toLowerCase() === "true";
    } catch (error) {
      console.error("Eroare de rețea la stergerea media", error);
      return false;
    }
  },

  getCommissionRates: async (): Promise<CommissionRateDto[] | null> => {
    try {
      const response = await fetch(AppConst.GLOBALS.getCommissionRatesUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include"
      });

      if (!response.ok) {
        return null;
      }

      return await response.json() as CommissionRateDto[];
    } catch (error) {
      return null;
    }
  },

  getListingPlans: async (): Promise<ListingPlanDto[] | null> => {
      try {
        const response = await fetch(AppConst.GLOBALS.getListingPlansUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        });

        if (!response.ok) {
          return null;
        }

        return await response.json() as ListingPlanDto[];
      } catch (error) {
        return null;
      }
    },

    forgotPassword: async (emailOrUsername: string): Promise<boolean> => {
        try {
          // 1. Extragem constantele de criptare inițializate la initApp
          var publicKey = AppConst.LOGIN_INIT.frameworkCSPF;
          var aDataCSPF = AppConst.LOGIN_INIT.aDataCSPF;

          // 2. Mapăm obiectul JSON structural
          const jsPayloadAsStr = JSON.stringify({ emailOrUsername: emailOrUsername });

          // 3. Criptăm payload-ul cu algoritmul simetric/asimetric încapsulat de platformă
          const payloadEncrypted = SjclManager.doEncrypt(publicKey, aDataCSPF, jsPayloadAsStr);

          const response = await fetch(AppConst.GLOBALS.forgotPasswordUrl, {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
            },
            credentials: 'include',
            body: payloadEncrypted, // 🟢 Trimitem pachetul securizat, exact cum așteaptă @RequestBody String în Java
          });

          if (!response.ok) {
            message.error({
              content: "Eroare de rețea la transmiterea solicitării.",
              duration: AppConst.msgDuration,
            });
            return false;
          }

          const jsonResponse = await response.json();

          if (jsonResponse.messages && jsonResponse.messages.length > 0) {
            jsonResponse.messages.forEach((msg: any) => {
              if (msg.type === "SUCCESS") {
                message.success({ content: msg.description, duration: AppConst.msgDuration });
              } else if (msg.type === "ERROR") {
                message.error({ content: msg.description, duration: AppConst.msgDuration });
              }
            });
          }

          return jsonResponse.cmd === "SHOW_MESSAGE";
        } catch (error) {
          console.error("Forgot password service error:", error);
          return false;
        }
      },

    queryLightRag: async (question: string, fields: string[]): Promise<Record<string, any>[] | null> => {
        try {
          const payload: LightRagQueryDto = {
            question,
            fields,
          };

          const response = await fetch(AppConst.GLOBALS.lightRagQueryUrl || "/endpoint/ai/query", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(payload),
          });

          if (!response.ok) {
            message.error({
              content: "Eroare de rețea la interogarea AI",
              duration: AppConst.msgDuration,
            });
            return null;
          }

          return await response.json() as Record<string, any>[];
        } catch (error) {
          console.error("Eroare de rețea în LightRAG query:", error);
          return null;
        }
      },
};